import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { CreateUserRequest, CreateUserResponse, DeleteUserRequest, DeleteUserResponse, ListUsersRequest, ListUsersResponse, UpdateUserRequest, UpdateUserResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminUserApi = createApi({
    reducerPath: "adminUserApi",
    baseQuery: baseQueryAdminWithAuth,
    tagTypes: ["Users"],
    endpoints: builder => ({
        listUsers: builder.query<ListUsersResponse, ListUsersRequest>({
            query: body => {
                const request = {
                    ...body,
                    sort: body.sort?.map(sort => ({
                        ...sort,
                        field: sort.field === "first_name"
                            ? "FirstName"
                            : sort.field === "last_name" ? "LastName" : sort.field
                    }))
                };
                return {
                    url: `user/list?${toDataSourceRequestString(request)}`,
                    method: "POST",
                    body: request
                };
            }
        }),
        createUser: builder.mutation<CreateUserResponse, CreateUserRequest>({
            query: body => ({
                url: "user/create",
                method: "POST",
                body
            })
        }),
        updateUser: builder.mutation<UpdateUserResponse, UpdateUserRequest>({
            query: body => ({
                url: "user/update",
                method: "POST",
                body
            })
        }),
        deleteUser: builder.mutation<DeleteUserResponse, DeleteUserRequest>({
            query: body => ({
                url: "user/delete",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useCreateUserMutation,
    useUpdateUserMutation,
    useDeleteUserMutation,
    useLazyListUsersQuery,
    useListUsersQuery
} = adminUserApi;
